import { Box, Typography, makeStyles, Tabs, Tab } from '@material-ui/core'
import React, { useEffect } from 'react'
import Wrapper from 'components/Wrapper'
import Templates from 'views/admin/configuration/Configuration/Templates'
import Setting from 'views/admin/configuration/Configuration/Setting'
import { Stack } from '@mui/material'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import { fetchConfig } from 'store/config'
import { useDispatch, useSelector } from 'react-redux'
import { Settings } from 'views/admin/configuration/Configuration/constants'
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined'
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'

const settings = {
  generalSetting: {
    label: 'General',
    icon: <SettingsOutlinedIcon />
  },
  emailSetting: {
    label: 'SMTP Server',
    icon: <MailOutlineIcon />
  },
  googleRecaptcha: {
    label: 'Google Recaptcha',
    icon: <RestartAltOutlinedIcon />
  },
  groqApi: {
    label: 'GROQ API Key',
    icon: <AutoAwesomeOutlinedIcon />
  },
  templates: {
    label: 'Email Templates',
    icon: <SourceOutlinedIcon />
  }
}

export const Configuration = () => {
  const classes = useStyles()
  const [value, setValue] = React.useState(settings.generalSetting.label)
  const dispatch = useDispatch()

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const { config, inProgress } = useSelector((state) => state.config)

  useEffect(() => {
    dispatch(fetchConfig())
  }, [dispatch])

  return (
    <>
      <Box className={classes.headBar}>
        <Typography variant="h5" className={classes.headerTitle}>
          Application Settings
        </Typography>
        <Stack justifyContent="center" alignItems="center">
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="off"
            className={classes.tabs}>
            {Object.keys(settings).map((key) => (
              <Tab
                label={settings[key].label}
                key={settings[key].label}
                value={settings[key].label}
                icon={settings[key].icon}
              />
            ))}
          </Tabs>
        </Stack>
      </Box>
      <Wrapper inProgress={inProgress}>
        <Box mt={3}>
          {value === settings.generalSetting.label && (
            <Setting config={config} fields={Settings.appSettings.fields} />
          )}
          {value === settings.emailSetting.label && (
            <Setting config={config} fields={Settings.emailSettings.fields} />
          )}
          {value === settings.googleRecaptcha.label && (
            <Setting config={config} fields={Settings.googleRecaptcha.fields} />
          )}
          {value === settings.groqApi.label && (
            <Setting config={config} fields={Settings.groqApi.fields} />
          )}
          {value === settings.templates.label && <Templates config={config} />}
        </Box>
      </Wrapper>
    </>
  )
}

export default Configuration

export const useStyles = makeStyles((theme) => ({
  headBar: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '2rem',
    zIndex: 99,
    position: 'sticky',
    top: 0,
    background: theme.palette.background.paper
  },
  headerTitle: {
    fontWeight: 600,
    color: '#263238'
  },
  tabs: {
    '& .MuiTab-root.MuiTab-labelIcon': {
      minHeight: '35px'
    },
    '& .MuiTab-root svg': {
      height: '20px',
      width: '20px',
      marginBottom: '0px !important'
    },
    '& .MuiTab-root .MuiTab-wrapper': {
      display: 'flex',
      flexDirection: 'row',
      gap: '8px',
      alignItems: 'center'
    },
    '& .MuiTab-root.Mui-selected': {
      color: theme.palette.primary.main
    }
  }
}))
